import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnLS: CultureInfo = {
  name: 'en-LS',
  displayName: 'English (Lesotho)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-LS',
  parent: CultureInfoEn
};
